import type { CanvasSize } from "../types.ts";

export const computeCanvasContainTransform = ({
  initialSize,
  targetSize,
}: {
  initialSize: CanvasSize;
  targetSize: CanvasSize;
}) => {
  let scale: number;
  if (
    initialSize.width <= targetSize.width &&
    initialSize.height <= targetSize.height
  ) {
    scale = 1;
  } else {
    scale = Math.min(
      targetSize.width / initialSize.width,
      targetSize.height / initialSize.height,
    );
  }

  const offsetX = (targetSize.width - initialSize.width * scale) / 2;
  const offsetY = (targetSize.height - initialSize.height * scale) / 2;

  return { scale, offsetX, offsetY };
};
